export const formatBeijingDateTime = (dateStr?: string | null): string => {
  if (!dateStr) return '';

  const hasTimeZone = /Z|[+-]\d{2}:\d{2}$/.test(dateStr);
  const normalized = hasTimeZone ? dateStr : `${dateStr}Z`;
  const date = new Date(normalized);

  return date.toLocaleString('zh-CN', {
    timeZone: 'Asia/Shanghai',
    hour12: false,
  });
};
